module.exports = __webpack_public_path__ + "static/media/girl-18.0e7aa85c.svg";